import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { KeyValue } from '@angular/common';
import { timeout } from 'rxjs/operators';
import { DeviceService } from './device.service';
import moment from 'moment';

@Injectable({ providedIn: 'root' })
export class SupplierJobService {
  constructor(private deviceService: DeviceService) {}

  transformArray<T, U extends keyof T>(collection: T[], prop: U) {
    if (!!collection)
      return collection.reduce((acc, curr) => {
        let key = (curr[prop] as any).toString();
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(curr);
        return acc;
      }, {} as { [key: string]: T[] });
  }

  calculateDistance(lon1, lat1, lon2, lat2) {
    var R = 6371; // Radius of the earth in km
    var dLat = this.toRadians(lat2 - lat1);
    var dLon = this.toRadians(lon2 - lon1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.toRadians(lat1)) *
        Math.cos(this.toRadians(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c; // Distance in km
    return d;
  }

  toRadians(coordDiff: number) {
    return (coordDiff * Math.PI) / 180;
  }

  /** Get the user Current location using the Navigator API */

  getCurrentLocation(timeoutMs: number): Observable<any> {
    return Observable.create((observer) => {
      if (window.navigator && window.navigator.geolocation) {
        let permissions = (navigator as any).permissions;
        if (!permissions) {
          try {
            navigator.geolocation.getCurrentPosition((pos) => {
              observer.next(pos);
              observer.complete();
            });
          } catch (err) {
            observer.error(new Error('GeoLocation permission not granted or not supported'));
          }
        } else {
          permissions
            ? // Permission API is implemented
              permissions
                .query({
                  // used as any pending the inclusion of the Permissions API which is currently in draft or upgrade to Typescript 3.5.3
                  name: 'geolocation',
                })
                .then((permission) =>
                  // is geolocation granted?
                  permission.state !== 'denied'
                    ? navigator.geolocation.getCurrentPosition((pos) => {
                        observer.next(pos);
                        observer.complete();
                      })
                    : observer.error(new Error('Permission API is not granted')),
                )
            : // Permission API was not implemented
              observer.error(new Error('Permission API is not supported'));
        }
      } else {
        console.log('Unsupported Browser');
        observer.error('Unsupported Browser');
      }
    }).pipe(timeout(timeoutMs));
  }

  // Preserve original property order
  originalOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
    return 0;
  };

  // Order by ascending property value
  valueAscOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
    return a.value.localeCompare(b.value);
  };

  // Order by descending property key
  keyDescOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
    return a.key > b.key ? -1 : b.key > a.key ? 1 : 0;
  };

  getTimeUntilStart(dateString: string) {
    let _dateString = new Date(dateString);
    if (moment() <= moment(_dateString)) {
      return `${moment(_dateString).fromNow()}`;
    } else {
      return `${moment(_dateString).fromNow()}`;
    }
  }

  getDistanceToLocation(longitude1, latitude1, longitude2, latitude2, format: string) {
    let distance = +this.calculateDistance(longitude1, latitude1, longitude2, latitude2);
    switch (format) {
      case 'miles':
        return `${(distance / 1.609).toFixed(0)} mi`;
      case 'kilometers':
        return `${distance.toFixed(0)} km`;
      default:
        return `${(distance / 1.609).toFixed(2)} mi`;
    }
  }
}
